var map = {
	"./contact-bg-m.png": 1147,
	"./contact-bg.png": 5270,
	"./device/device-1.png": 1021,
	"./device/device-2.png": 2304,
	"./device/device-3.png": 7451,
	"./device/device-4.png": 2336,
	"./device/device-5.png": 5038,
	"./device/device-6.png": 5479,
	"./device/device-7.png": 2001,
	"./device/device-8.png": 5120,
	"./gradient-bottom.png": 5572,
	"./gradient-top.png": 9591,
	"./logo.png": 6949,
	"./section-1.png": 9756,
	"./section-11-bg.png": 8563,
	"./section-13-bg.png": 7376,
	"./section-13.png": 9565,
	"./section-14-bg.png": 9120,
	"./section-15-bg.png": 3118,
	"./section-17-bg.png": 3991,
	"./section-19-bg.png": 8304,
	"./section-2-bg.png": 86,
	"./section-20-bg.png": 1351,
	"./section-3-bg.png": 2894,
	"./section-4-1-bg.png": 8675,
	"./section-4-2-bg.png": 7328,
	"./section-4-3-bg.png": 919,
	"./section-4-bg.png": 4247,
	"./section-5-bg.png": 7030,
	"./section-6-2-bg.png": 6550,
	"./section-6-bg.png": 3750,
	"./section-7-bg.png": 6271,
	"./section-8-bg.png": 7420,
	"./section-9.png": 5789,
	"./section-bg-12.png": 8733,
	"./section-bg-21.png": 4186,
	"./starlink_svr.png": 7284,
	"./starlink_tracker.png": 6020,
	"./tcoin.png": 5300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;